import React from "react";
import { Lock, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/helpers";

function GallynomicsCard({ article }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() =>
        navigate(
          `/gallionomics/details/${slugify(article.category.name)}/${slugify(
            article.article_title
          )}/${article.id}`
        )
      }
      className="w-[300px] bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex-shrink-0"
    >
      {/* Image Section */}
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.cover_image_url}
          alt={article.article_title}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
      </div>

      {/* Content */}
      <div className="p-4">
        {/* Category */}
        <div className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 mb-2">
          {article.category.name}
        </div>

        {/* Title */}
        <h2 className="cursor-pointer text-lg font-bold text-gray-900 mb-1 truncate whitespace-nowrap overflow-hidden">
          {article.article_title}
        </h2>

        {/* Meta Info */}
        <p className="text-xs text-gray-500">
          {new Date(article.created_at).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          })}{" "}
        </p>
      </div>
    </div>
  );
}

export default GallynomicsCard;
